import styled from "styled-components";
import { Image } from "../../../../../raw-components/image/image";

export const LogoImageSiBox = styled(Image)`
    display: block;
    margin: 0 auto;
    height: 26px;
`;
